import { ClearFiltersButton } from '../../components/clearFiltersButton.tsx';
import { ComboBox } from '../../components/comboBox.tsx';
import { trpc } from '../../utils/trpc/trpc.ts';


interface Props {
    partName: string;
    setPartName: (partName: string) => void;
}

export function PartNameInput({
    partName,
    setPartName,
}: Props) {
    const { data: partNames } = trpc.products.getPartNames.useQuery(
        undefined,
        {
            refetchInterval: 10 * 60_000,
            select: (partNames) => [...partNames.sort()],
        }
    );

    return (
        <div style={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
            <ComboBox
                dataId='partNameForm'
                label='Part number'
                defaultValue={partName}
                suggestions={partNames ?? []}
                onSubmit={setPartName}
            />
            <ClearFiltersButton
                style={{ marginRight: '16px' }}
                onClick={() => setPartName('')}
            />
        </div>
    )
}
